<h2 mat-dialog-title>Custom date</h2>

<mat-dialog-content>
  <form class="custom-date__fields" [formGroup]="form">
    <ifc-datepicker [fc]="fromControl" [label]="'From'" [max]="todayDate" [clearDisabled]="true"></ifc-datepicker>
    <ifc-datepicker
      [fc]="toControl"
      [label]="'To'"
      [min]="toMinDate"
      [max]="todayDate"
      [clearDisabled]="true"
    ></ifc-datepicker>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="flex row end-center">
  <button mat-button [color]="ButtonColor.Default" (click)="onCancel()">CANCEL</button>
  <button mat-button [color]="ButtonColor.Primary" [disabled]="submitDisabled" (click)="onSubmit()">SUBMIT</button>
</mat-dialog-actions>
